import { useState, useEffect, useRef } from "react";

import { api } from "./pureFunctions"
import Button from "react-bootstrap/Button";
import MyToolTip from "./MyToolTip";
import { Spinner } from "react-bootstrap";

function TabMenu({ estatekacheln, loading, sendData, eskstatus }) {
   const [showDisabled, setShowDisabled] = useState(false);
   return (
      <>
         <div className="text-center text-lg-start">
            <Button
               className="mb-2"
               variant={showDisabled ? "secondary" : "outline-secondary"}
               onClick={() => setShowDisabled((prev) => !prev)}
            >
               Entfernte/Zusatz Kacheln
            </Button>

            {showDisabled && (
               <div>
                  <p>Um eine entfernte Kachel wieder hinzuzufügen, einfach auf den passenden Namen unten klicken.</p>
                  {estatekacheln.map((m_item, index) => {
                     return (
                        <button
                           type="button"
                           disabled={loading}
                           key={m_item+"_"+index}
                           className="tabmenu-button me-2 mb-2"
                           onClick={(e) => {
                              console.log(e);
                              e.stopPropagation();
                              e.preventDefault();
                              console.log(m_item);
                              
                              let newEskStatus = structuredClone(eskstatus);
                              newEskStatus["kachel_status_" + m_item.kachelId] = 1;
                              sendData({  postEskData: newEskStatus });
                           }}
                        >
                           {loading ? (
                              <Spinner as="span" animation="grow" size="sm" role="status" aria-hidden="true" />
                           ) : (
                              m_item.heading
                           )}
                        </button>
                     );
                  })}
               </div>
            )}
         </div>
      </>
   );
}

export default TabMenu;
